export default __webpack_public_path__ + "static/media/LAN.414d6d1a.png";